<template>
  <div class="animated fadeIn">
    <basic-heading title="Managed Lists" class="mb-3" />
    <permission-alert-gate :permissions="'list managed list'">
      <template #gated-content>
        <managed-lists-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import ManagedListsTable from "@/components/lab/managedlists/ManagedListsTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";

export default {
  name: "ManagedListsIndex",
  components: {
    BasicHeading,
    ManagedListsTable,
    PermissionAlertGate,
  },
};
</script>
